var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "#fff",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.458 12c0 6.329-5.13 11.459-11.458 11.459S.542 18.329.542 12C.542 5.672 5.672.542 12 .542s11.458 5.13 11.458 11.459ZM13.042 10.96c-1.25-1.25-2.43-1.042-3.125-.521l-1.042 1.041c.092 0 .226-.035.388-.079.454-.121 1.125-.301 1.696.08.93.62.568 1.24.012 2.19-.377.646-.843 1.444-1.054 2.497-.52 2.604 2.083 2.604 4.167 1.042-3.334.833-2.778-.695-2.084-1.563.868-1.042 2.292-3.437 1.042-4.687Zm.52-1.042a1.562 1.562 0 1 0 0-3.125 1.562 1.562 0 0 0 0 3.125Z"
  })));
};

export default SvgInfo;